import {
  Directive,
  Input,
  ViewContainerRef,
  ComponentRef,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[dynamicCellHost]'
})
export class DynamicCellHostDirective
  implements OnInit, OnChanges, OnDestroy {

  @Input('dynamicCellHost') component!: any;
  @Input() componentInputs?: any;
  @Input() componentOutputs?: { [key: string]: (value: any) => void };

  private componentRef?: ComponentRef<any>;
  private outputSubs: Subscription[] = [];

  constructor(private vcr: ViewContainerRef) {}

  ngOnInit() {
    this.cleanup();

    if (!this.component) return;

    this.componentRef = this.vcr.createComponent(this.component);


    if (this.componentInputs) {
      Object.assign(this.componentRef.instance, this.componentInputs);
    }


    if (this.componentOutputs) {
      Object.entries(this.componentOutputs).forEach(([event, handler]) => {
        const emitter = this.componentRef!.instance[event];
        if (emitter?.subscribe) {
          this.outputSubs.push(emitter.subscribe(handler));
        }
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.componentRef) return;

    if (changes['componentInputs'] && this.componentInputs) {
      Object.assign(this.componentRef.instance, this.componentInputs);
    }
  }

  private cleanup() {
    this.outputSubs.forEach(sub => sub.unsubscribe());
    this.outputSubs = [];
    this.vcr.clear();
  }

  ngOnDestroy() {
    this.cleanup();
    this.componentRef?.destroy();
  }
}
